import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import AppsDropdown from '../products/apps-dropdown'

import { AllApps } from '../../queries/types/AllApps'
import { findOrdersQuery, getAllAppsQuery } from '../../queries'
import { FindOrders, FindOrdersVariables } from '../../queries/types/FindOrders'
import { useLazyQuery, useQuery } from '@apollo/client'
import { OrderRow } from './row'
import { App } from '../../types/global'
import { ApolloStatePrimaryButton } from '../button'
import { EmptyState, LoadingRows, PageHeader, TableCard, TableHead, TableMessageRow } from '../ui'

const COLUMN_COUNT = 8

export function OrderListing(): JSX.Element {
    const { t } = useTranslation()
    const { data: apps } = useQuery<AllApps>(getAllAppsQuery)
    const [ fetchOrders, fetchOrdersResult ] = useLazyQuery<FindOrders, FindOrdersVariables>(findOrdersQuery, {
        fetchPolicy: 'cache-and-network'
    })
    const [app, setApp] = useState<App|null>(null)

    function showOrders() {
        if (app) {
            if (fetchOrdersResult.called) {
                return fetchOrdersResult.refetch({
                    appID: app.id,
                    limit: 100
                })
            } else {
                return fetchOrders({
                    variables: {
                        appID: app.id,
                        limit: 100
                    }
                })
            }
        }
    }
    useEffect(() => {
        showOrders()
    }, [app])

    const orders = fetchOrdersResult.data?.findOrders

    function tableBody() {
        if (!app) {
            return <TableMessageRow colSpan={COLUMN_COUNT}><EmptyState title={t('shared.state.select-app-title')} subtitle={t('orders.select-app.subtitle')} /></TableMessageRow>
        }
        if (!orders && fetchOrdersResult.loading) {
            return <TableMessageRow colSpan={COLUMN_COUNT}><LoadingRows message={t('orders.loading')} /></TableMessageRow>
        }
        if (orders && orders.length === 0) {
            return <TableMessageRow colSpan={COLUMN_COUNT}><EmptyState title={t('orders.empty.title')} subtitle={t('orders.empty.subtitle')} /></TableMessageRow>
        }
        return orders?.map((order) => <OrderRow key={order.id} order={order} />)
    }

    return (
        <>
            <PageHeader title={t('orders.title')} subtitle={app ? t('orders.head.footer') : undefined}>
                {apps ? <AppsDropdown items={apps.apps} selected={app} onDidSelect={setApp} className='w-full sm:w-56' /> : null}
                <ApolloStatePrimaryButton onClick={() => showOrders()} result={fetchOrdersResult}>
                    {t('orders.head.buttons.refresh')}
                </ApolloStatePrimaryButton>
            </PageHeader>
            <TableCard>
                <TableHead columns={[
                    t('orders.table.titles.id'),
                    t('orders.table.titles.product'),
                    t('orders.table.titles.paymentMethod'),
                    t('orders.table.titles.amount'),
                    t('orders.table.titles.status'),
                    t('orders.table.titles.callback-status'),
                    t('orders.table.titles.createdAt'),
                    <span key='actions' className='sr-only'>{t('orders.table.titles.actions')}</span>,
                ]} />
                <tbody>{tableBody()}</tbody>
            </TableCard>
        </>
    )
}
